import { useMap } from 'react-leaflet';
import L from 'leaflet';
import { useEffect } from 'react';

const MapResetControl = ({ onReset, visible }) => {
  const map = useMap();

  useEffect(() => {
    const resetControl = L.Control.extend({
      onAdd: function() {
        const container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom');
        
        const button = L.DomUtil.create('a', '', container);
        button.innerHTML = '×';
        button.href = '#';
        button.title = 'Reset Map';
        button.style.backgroundColor = 'white';
        button.style.width = '30px';
        button.style.height = '30px';
        button.style.lineHeight = '30px';
        button.style.textAlign = 'center';
        button.style.textDecoration = 'none';
        button.style.color = '#333';
        button.style.fontSize = '20px';
        button.style.fontWeight = 'bold';
        button.style.border = '2px solid rgba(0,0,0,0.2)';
        button.style.borderRadius = '4px';
        button.style.display = visible ? 'block' : 'none';
        
        L.DomEvent.on(button, 'click', function(e) {
          L.DomEvent.stopPropagation(e);
          L.DomEvent.preventDefault(e);
          onReset();
        });
        
        // Prevent map events when clicking the button
        L.DomEvent.disableClickPropagation(container);
        
        return container;
      }
    });

    const control = new resetControl({ position: 'topright' });
    map.addControl(control);

    return () => {
      map.removeControl(control);
    };
  }, [map, onReset, visible]);

  return null;
};

export default MapResetControl;